import React, { useEffect, useState } from "react";
import JobListingTeacher from "./Teacher/JobListingTeacher";
import JobListingCollege from "./College/JobListingCollege";
import JobListingCommon from "./JobListingCommon";
import JobListingAdmin from "./JoblistingAdmin";
// import { verifyUserRole } from "../../Helper";
import Auth from "../../Auth/Auth";
import { API } from "../../API";
import Spinner from "../../Components/Spinner/Spinner";
// import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

function JobListing(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [job, setJob] = useState({});
  const [inst, setInst] = useState({});
  const [campus, setCampus] = useState({});

  const { search, pathname } = useLocation();
  const searchParams = new URLSearchParams(search);

  useEffect(() => {
    const listing_id = props.match.params.id;
    API.getListingById(listing_id)
      .then((res) => {
        const listing = res.data.listing;
        // console.log(listing)
        setJob(listing);
        API.getInstitutionDataById(listing.inst_id).then((res) => {
          // console.log(res.data)
          if (res.data) {
            setInst({
              _id: res.data._id,
              institution_name: res.data.institution_name,
              logo: res.data.logo,
            });
          }
          API.getMultipleCampusById([listing.location]).then((res) => {
            // console.log(res.data)
            if (res.data[0]) {
              setCampus({
                campus_shortname: res.data[0].campus_shortname,
                suburb: res.data[0].suburb,
                timezone: res.data[0].timezone,
              });
            }
            setIsLoaded(true);
          });
        });
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, []);

  const displayListing = () => {
    const role = Auth.verifyUserRole();
    // console.log(role)

    if (isLoaded) {
      // teachers cannot view drafts, only the institution that owns the draft can view it
      if (role === "admin") {
        return <JobListingAdmin job={job} inst={inst} campus={campus} />;
      } else if (role === "teacher" && job.status === "published") {
        return <JobListingTeacher job={job} inst={inst} campus={campus} />;
      } else if (role === "customer" || role === "personnel") {
        // draft/published display handling is done within the component
        return <JobListingCollege job={job} inst={inst} campus={campus} />;
      } else if (job.status === "published") {
        const teacherId = searchParams.get("t_id")
        if (teacherId && teacherId.length > 0 && pathname.includes("/JobListing/")) {
          sessionStorage.setItem("listing_path", pathname)
          sessionStorage.setItem("teacher_id", teacherId)
          window.location = '/Login'
        }
        return <JobListingCommon job={job} inst={inst} campus={campus} />;
      }
    } else {
      return <Spinner />;
    }
  };

  const link_img =
    "https://readyteacher-public-images.s3-ap-southeast-2.amazonaws.com/Jobs+(1).jpg";
  const title = isLoaded ? `${job.title} - ReadyTeacher` : "ReadyTeacher";

  return (
    <>
      {/* <Helmet>
        <meta property="og:title" content={title} />
        <title>{title}</title>
        <meta name="image" property="og:image"
          content={link_img} />
        <link rel="image_src" href={link_img} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:image" content={link_img} />
      </Helmet> */}
      {displayListing()}
    </>
  );
}

export default JobListing;
